<template>
    <div class="custom-progress-bar" :style="{ height: `${height}px`, borderRadius: `${height / 2}px` }">
        <div class="custom-progress-bar__track"></div>
        <div
            class="custom-progress-bar__fill"
            :style="fillStyle"
        ></div>
        <slot></slot>
    </div>
</template>
<!---------------------------------------------------------------------------->
<script>
export default {
    props: {
        percent: {
            type: Number,
            default: 85.7,
            validator: (value) => value >= 0 && value <= 100
        },
        height: {
            type: Number,
            default: 8
        },
        gradientStart: {
            type: String,
            default: '#6CD99D'
        },
        gradientEnd: {
            type: String,
            default: '#0CB43F'
        }
    },
    computed: {
        fillStyle() {
            return {
                width: `${this.percent}%`,
                background: `linear-gradient(to right, ${this.gradientStart}, ${this.gradientEnd})`,
                borderRadius: `${this.height / 2}px`
            };
        }
    }
};
</script>
<!---------------------------------------------------------------------------->
<style lang="scss" scoped>
.custom-progress-bar {
    position: relative;
    width: 100%;
    border-radius: 4px;
    overflow: hidden;

    &__track {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #EBEDF5;
        border-radius: 4px;
        box-shadow: inset 0 0 0 0.5px rgba(0, 0, 0, 0.04);
    }

    &__fill {
        position: relative;
        height: 100%;
        border-radius: 4px;
        transition: width 0.3s ease;
        z-index: 1;
    }
}
</style>
